import { Modal } from 'react-bootstrap'
import React, { Component } from 'react'

export default class PopupModal extends Component {
  render() {
    return (
      <div>
        <Modal
          size={this.props.size}
          centered={this.props.centered}
          {...this.props}
          show={this.props.show}
          onHide={this.props.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.props.Title}</Modal.Title>
            {this.props.extraButtons}
          </Modal.Header>
          {this.props.children}
        </Modal>
      </div>
    )
  }
}
